<template>
  <div class="flex w-full items-center gap-3">
    <Box v-for="(title, index) in props.steps"
         :key="`${index}-${title}`"
         @click="goTo(index + 1)"
         :title="title"
         :class="stepClass(index + 1)"/>
  </div>
</template>

<script setup>
import {computed} from "vue"
import Box from "@/components/stepper/Box.vue"

const props = defineProps({
  steps: {
    type: Array,
    required: true
  },
  modelValue: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const goTo = step => value.value = step
const stepClass = step => {
  if (step < value.value) return 'step-done'
  if (step === value.value) return 'step-active'
  return 'step-inactive'
}

</script>
